import React from 'react'

const OderSumission = () => {
  return (
    <div  className='order-submission'>
        
        
         <h4>Order Id-025</h4>

         <h1>YOUR ORDER IS SUCCESSFULLY PLACED</h1>

         <h3>Thank You !</h3>
        
        
        </div>
  )
}

export default OderSumission